import React, { useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom";

import { IS_LOCALHOST } from "./constants/Config";
import { GetEnvVariables } from "./utils";
import App from "./App";
import { updateConfigs } from "./constants/Config";

const AppWithAuthentication = () => {
  const [config, setConfig] = useState();
  const [isConfigLoaded, setIsConfigLoaded] = useState(false);
  const variables = useMemo(
    () => {
      const envVariables = {
        REACT_APP_PROVIDER_FINDER_BASE_URL: "[_PROVIDER_FINDER_BASE_URL_]",
        REACT_APP_GOOGLE_API_MAP_KEY: "[_APP_GOOGLE_API_MAP_KEY_]",
      };
     return IS_LOCALHOST ? GetEnvVariables() : envVariables;
    },
    [],
  );
  useEffect(() => {
    (async () => {
      if (!config) {
        setConfig(variables);
        updateConfigs(variables);
        setIsConfigLoaded(true);
      }
    })();
  }, [config, variables]);

  return (
    <div>
      {isConfigLoaded ? (
        <React.StrictMode>
          <App />
        </React.StrictMode>
      ) : (
        <>Loading...</>
      )}
    </div>
  );
};

ReactDOM.render(<AppWithAuthentication />, document.getElementById("root"));
